import { render, staticRenderFns } from "./DraftCard.vue?vue&type=template&id=9f629bd2&scoped=true&"
import script from "./DraftCard.vue?vue&type=script&lang=js&"
export * from "./DraftCard.vue?vue&type=script&lang=js&"
import style0 from "./DraftCard.vue?vue&type=style&index=0&id=9f629bd2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f629bd2",
  null
  
)

export default component.exports